import { render, staticRenderFns } from "./SleepingMain.vue?vue&type=template&id=64b8cdf5&scoped=true&"
import script from "./SleepingMain.vue?vue&type=script&lang=js&"
export * from "./SleepingMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8cdf5",
  null
  
)

export default component.exports